import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { registerStaleChunkRecovery } from './app/core/utils/stale-chunk-recovery';

registerStaleChunkRecovery();

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
